import { useCallback } from "react";
import { useNavigate, useParams } from "react-router";
import { useDeleteThread } from "@queries/chat/useDeleteThread";
import { useThreadsStore } from "@store/threads.store";

const DELETE_THREAD_UI_DELAY_MS = 50;

/**
 * Thread orchestration shared across chat UI (delete flow, navigation, store sync).
 */
export const useThreadLogic = () => {
  const navigate = useNavigate();
  const { threadId: currentThreadId } = useParams<{ threadId?: string }>();
  const removeThread = useThreadsStore((state) => state.removeThread);
  const deleteThreadMutation = useDeleteThread();

  const deleteThread = useCallback(
    (threadId: string) => {
      setTimeout(() => {
        removeThread(threadId);
        deleteThreadMutation.mutate({ threadId });

        const shouldNavigateHome =
          currentThreadId != null && currentThreadId === threadId;

        if (shouldNavigateHome) {
          navigate("/");
        }
      }, DELETE_THREAD_UI_DELAY_MS);
    },
    [removeThread, deleteThreadMutation, navigate, currentThreadId],
  );

  return { deleteThread };
};
